// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Poz7a","colCheckbox":"styles_colCheckbox__Wkz-_"};